<div class="wrapper" [ngClass]="{ backdrop: open }">
  <div class="modal" [ngClass]="{ open: open }" [ngStyle]="addWidth()">
    <ng-content></ng-content>
  </div>
</div>
